import React from 'react'
import { easement_val_data } from '../../data/valuationData';

const EasementValuationPage = () => {
  return (
    <div className="px-[5vw] sm:px-[10vw] xl:px-[15vw] flex flex-col items-center sm:flex-row pt-[120px] gap-5">
          <div className='h-auto'>
            <h1 className="py-2 text-2xl lg:text-3xl font-playfair">
              {easement_val_data.title}
            </h1>
    
            <div className="w-full space-y-5 py-10">
              <p>{easement_val_data.description}</p>
              <p>{easement_val_data.para}</p>
              <p>{easement_val_data.para1}</p>
            </div>
          </div>
        </div>
  )
}

export default EasementValuationPage;